webpackJsonp([82],{

/***/ 1345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeRule;
/*
 * 根据给定的多个文件路径引入模块
 * @Author: anker.wang
 * @Date: 2018-01-08 11:23:04
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-07-26 12:37:26
 */

/**
 * 快速制作验证规则
 * https://github.com/yiminghe/async-validator
 * @param {*} message
 * @param {*} type
 * @param {*} trigger
 * @param {*} required
 *
 string: Must be of type string. This is the default type.
 number: Must be of type number.
 boolean: Must be of type boolean.
 method: Must be of type function.
 regexp: Must be an instance of RegExp or a string that does not generate an exception when creating a new RegExp.
 integer: Must be of type number and an integer.
 float: Must be of type number and a floating point number.
 array: Must be an array as determined by Array.isArray.
 object: Must be of type object and not Array.isArray.
 enum: Value must exist in the enum.
 date: Value must be valid as determined by Date
 url: Must be of type url.
 hex: Must be of type hex.
 email: Must be of type email.
 */
function makeRule(message) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'string';
  var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'blur';
  var required = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  var rule = { message: message, type: type, trigger: trigger, required: required };
  rule.transform = function (value) {
    // 为空字符串时转换为null
    value === '' && (value = null);
    // 数字类型忽略为null的数字转换
    if (value !== null && ['number', 'integer', 'float'].includes(type)) {
      value = Number(value);
    }
    return value;
  };
  return rule;
}

/***/ }),

/***/ 2164:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return searchRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formRules; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__ = __webpack_require__(1345);



var searchRules = {
  id: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入正确的图片流转配置ID', 'integer', 'blur', false), { min: 1 })],
  batch_id: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入正确的批次ID', 'integer', 'blur', false), { min: 1 })]
};

var formRules = {
  name: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入图片流转配置名称', 'string')), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入至少2个字符', 'string'), { min: 2 })],
  customer_id: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择客户', 'integer'), { min: 1 })],
  project_id: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择项目', 'integer'), { min: 1 })],
  batch_id: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择批次', 'integer'), { min: 1 })],
  step_template_id: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择分布模板', 'integer'), { min: 1 })],
  step_template_question_ids: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择分布模板问题', 'array'), { min: 1 })],
  model_id: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择模型', 'integer'), { min: 1 })]
};

/***/ }),

/***/ 2715:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__img_flow_config_rules_js__ = __webpack_require__(2164);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      id: 0,
      formRules: __WEBPACK_IMPORTED_MODULE_2__img_flow_config_rules_js__["a" /* formRules */],
      form: {
        name: '',
        customer_id: '',
        customer_name: '',
        project_id: '',
        project_name: '',
        batch_id: '',
        batch_name: '',
        step_template_id: '',
        step_template_question_ids: [],
        splice_question_ids: [],
        model_id: ''
      },
      questions: [],
      spliceQuestions: []
    };
  },

  computed: {},
  watch: {},
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      return vm.onLoad();
    });
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.onReload();
    next();
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, request.map(['getImgFlowModelTable', 'getImgFlowModelDetail', 'getCustomerTable', 'getCustomerDetail', 'getProjectTable', 'getProjectDetail', 'getBatchTable', 'getBatchDetail', 'getStepTemplateTable', 'getStepTemplateDetail']), {
    onLoad: function onLoad() {
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id);
      }
    },
    onReload: function onReload() {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.call(this));
      this.onLoad();
    },
    setForm: function setForm(id) {
      var _this = this;

      request.page('getImgFlowConfigDetail', { id: id }).then(function (_ref) {
        var data = _ref.data;

        request.page('getStepTemplateDetail', { id: data.step_template_id }).then(function (_ref2) {
          var data = _ref2.data;

          _this.setQuestions(JSON.parse(data.json));
          _this.changeQuestionIds();
        });
        data.customer_id = String(data.customer_id);
        data.project_id = String(data.project_id);
        data.batch_id = String(data.batch_id);
        data.step_template_id = String(data.step_template_id);
        filter.setLoop(_this.form, data);
      });
    },
    getForm: function getForm() {
      return filter.copyJson(this.form);
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      this.$refs['form'].validate(function (valid) {
        if (valid) {
          _this2.id ? _this2.update(_this2.id) : _this2.create();
        } else {
          _this2.$message.error('提交内容填写不正确！');
        }
      });
    },
    create: function create() {
      var _this3 = this;

      request.common('createImgFlowConfigData', this.getForm()).then(function (res) {
        _this3.$confirm(_this3.$route.meta.title + '成功, 是否继续添加？', '提示', { type: 'success' }).then(function () {
          _this3.$refs.form.resetFields();
        }, function () {
          _this3.$router.push({ path: '/img-flow-config/table/' });
        });
      });
    },
    update: function update(id) {
      var _this4 = this;

      request.common('updateImgFlowConfigData', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ id: id }, this.getForm())).then(function (res) {
        _this4.$confirm(_this4.$route.meta.title + '成功, 是否前往列表页面？', '提示', { type: 'success' }).then(function () {
          _this4.$router.push({ path: '/img-flow-config/table/' });
        });
      });
    },
    stepTemplateChange: function stepTemplateChange(value) {
      var _this5 = this;

      this.questions = [];
      this.form.step_template_question_ids = [];
      return this.getStepTemplateDetail({ id: value.id }).then(function (_ref3) {
        var data = _ref3.data;

        _this5.setQuestions(JSON.parse(data.json));
      });
    },
    setQuestions: function setQuestions(questions) {
      this.questions = questions.map(function (question, index) {
        return {
          key: question.stepId,
          label: 'Q' + (index + 1) + ' ' + question.title
        };
      });
    },
    changeQuestionIds: function changeQuestionIds() {
      var _this6 = this;

      // 获得拼接题目列表
      var questions = [];
      this.questions.forEach(function (question) {
        if (_this6.form.step_template_question_ids.includes(question.key)) {
          questions.push(question);
        }
      });
      // 清除无效的已选选项
      var spliceIds = this.form.splice_question_ids.concat();
      spliceIds.forEach(function (id, index) {
        if (!_this6.form.step_template_question_ids.includes(id)) {
          _this6.form.splice_question_ids.splice(index, 1);
        }
      });
      this.spliceQuestions = questions;
    }
  })
});

/***/ }),

/***/ 296:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImgFlowConfigForm_vue__ = __webpack_require__(2715);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_302d3c18_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImgFlowConfigForm_vue__ = __webpack_require__(4152);
function injectStyle (ssrContext) {
  __webpack_require__(4146)
  __webpack_require__(4148)
  this["$style"] = __webpack_require__(4150)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-302d3c18"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImgFlowConfigForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_302d3c18_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImgFlowConfigForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 4146:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4147);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("3d5b7d9d", content, true, {});

/***/ }),

/***/ 4147:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"ImgFlowConfigForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4148:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4149);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("20a9411e", content, true, {});

/***/ }),

/***/ 4149:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"ImgFlowConfigForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4150:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4151);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("eeb063da", content, true, {});

/***/ }),

/***/ 4151:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"ImgFlowConfigForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4152:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":"/img-flow-config/table"}},[_vm._v("图片流转配置列表")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('span',{attrs:{"slot":"header"},slot:"header"},[_vm._v("表单")]),_vm._v(" "),_c('el-form',{ref:"form",attrs:{"model":_vm.form,"rules":_vm.formRules,"size":"medium","label-width":"140px"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmit()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('div',{staticClass:"medium"},[_c('el-form-item',{attrs:{"label":"流转名称","prop":"name"}},[_c('el-input',{attrs:{"placeholder":"请输入流转名称"},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"所属客户","prop":"customer_id"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"number","label-key":"name","value-key":"id","placeholder":"请输入客户关键字","query-request":_vm.getCustomerTable,"find-request":_vm.getCustomerDetail},on:{"change":function (value) { _vm.form.customer_name=value.name;_vm.form.project_id='';_vm.form.batch_id='';_vm.$refs.projectSelect.emptyOptions(); }},model:{value:(_vm.form.customer_id),callback:function ($$v) {_vm.$set(_vm.form, "customer_id", $$v)},expression:"form.customer_id"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"所属项目","prop":"project_id"}},[_c('remote-select',{ref:"projectSelect",staticClass:"width-max",attrs:{"clearable":"","id-key":"number","label-key":"name","value-key":"id","placeholder":"请输入项目关键字","disabled":!_vm.form.customer_id,"query-request":function (_){ return _vm.getProjectTable(Object.assign({customerid: _vm.form.customer_id}, _)); },"find-request":_vm.getProjectDetail},on:{"change":function (value) { _vm.form.project_name=value.name;_vm.form.batch_id = '';_vm.$refs.batchSelect.emptyOptions(); }},model:{value:(_vm.form.project_id),callback:function ($$v) {_vm.$set(_vm.form, "project_id", $$v)},expression:"form.project_id"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"所属批次","prop":"batch_id"}},[_c('remote-select',{ref:"batchSelect",staticClass:"width-max",attrs:{"clearable":"","id-key":"number","label-key":"detail","value-key":"id","placeholder":"请输入批次关键字","disabled":!_vm.form.project_id,"query-request":function (_){ return _vm.getBatchTable(Object.assign({customerid: _vm.form.customer_id, projectid:_vm.form.project_id}, _)); },"find-request":_vm.getBatchDetail},on:{"change":function (value) { _vm.form.batch_name=value.detail||value.number }},model:{value:(_vm.form.batch_id),callback:function ($$v) {_vm.$set(_vm.form, "batch_id", $$v)},expression:"form.batch_id"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"所属分步模板","prop":"step_template_id"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"id","label-key":"title","value-key":"id","placeholder":"请输入分步任务模板关键字","query-request":_vm.getStepTemplateTable,"find-request":_vm.getStepTemplateDetail},on:{"change":_vm.stepTemplateChange},model:{value:(_vm.form.step_template_id),callback:function ($$v) {_vm.$set(_vm.form, "step_template_id", $$v)},expression:"form.step_template_id"}})],1)],1)]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"模板识别题目","prop":"step_template_question_ids"}},[_c('el-transfer',{attrs:{"filterable":"","filter-placeholder":"请输入题目关键字","data":_vm.questions,"titles":['未选', '已选']},on:{"change":_vm.changeQuestionIds},model:{value:(_vm.form.step_template_question_ids),callback:function ($$v) {_vm.$set(_vm.form, "step_template_question_ids", $$v)},expression:"form.step_template_question_ids"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"图片拼接题目","prop":"splice_question_ids"}},[_c('el-transfer',{attrs:{"filterable":"","filter-placeholder":"请输入题目关键字","data":_vm.spliceQuestions,"titles":['未选', '已选']},model:{value:(_vm.form.splice_question_ids),callback:function ($$v) {_vm.$set(_vm.form, "splice_question_ids", $$v)},expression:"form.splice_question_ids"}})],1),_vm._v(" "),_c('div',{staticClass:"re-el-form__flex"},[_c('div',{staticClass:"medium"},[_c('el-form-item',{attrs:{"label":"识别模型","prop":"model_id"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"name","label-key":"alias","value-key":"id","placeholder":"请输入模型关键字","query-request":_vm.getImgFlowModelTable,"find-request":_vm.getImgFlowModelDetail},model:{value:(_vm.form.model_id),callback:function ($$v) {_vm.$set(_vm.form, "model_id", $$v)},expression:"form.model_id"}})],1)],1)]),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","native-type":"submit"}},[_vm._v("提交表单\n        ")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.onReload}},[_vm._v("重置")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/img-flow-config-form.72c694e9e47c0ea2ee51.js